// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-quick-panel {
  display: flex;
  width: 350px;
  min-width: 350px;
  max-width: 350px;
  z-index: 99;
  flex-direction: column;
}
app-quick-panel .mat-slide-toggle-content {
  flex: 1;
}
app-quick-panel .span-spacer {
  flex: 1 1 auto;
}
app-quick-panel .time-alert {
  text-align: right;
  color: gray;
  margin-top: 10px;
}
app-quick-panel .cursor-pointer {
  float: right;
  cursor: pointer;
}
app-quick-panel .mat-list-text {
  padding-right: 16px !important;
}
app-quick-panel .show-alert {
  height: auto !important;
  margin-bottom: 25px;
  margin-top: 15px;
}
app-quick-panel .show-alert .error-message {
  white-space: inherit !important;
}`, "",{"version":3,"sources":["webpack://./src/app/main/quick-panel/quick-panel.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AACF;AACE;EACE,OAAA;AACJ;AAEE;EACE,cAAA;AAAJ;AAGE;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;AADJ;AAIE;EACE,YAAA;EACA,eAAA;AAFJ;AAKE;EACE,8BAAA;AAHJ;AAME;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;AAMI;EACE,+BAAA;AAJN","sourcesContent":["app-quick-panel {\r\n  display: flex;\r\n  width: 350px;\r\n  min-width: 350px;\r\n  max-width: 350px;\r\n  z-index: 99;\r\n  flex-direction: column;\r\n\r\n  .mat-slide-toggle-content {\r\n    flex: 1;\r\n  }\r\n\r\n  .span-spacer {\r\n    flex: 1 1 auto;\r\n  }\r\n\r\n  .time-alert {\r\n    text-align: right;\r\n    color: gray;\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .cursor-pointer {\r\n    float: right;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .mat-list-text {\r\n    padding-right: 16px !important;\r\n  }\r\n\r\n  .show-alert {\r\n    height: auto !important;\r\n    margin-bottom: 25px;\r\n    margin-top: 15px;\r\n\r\n    .error-message {\r\n      white-space: inherit !important;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
